import { render, staticRenderFns } from "./tab10.vue?vue&type=template&id=2021ac2a"
import script from "./tab10.vue?vue&type=script&lang=js"
export * from "./tab10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2021ac2a')) {
      api.createRecord('2021ac2a', component.options)
    } else {
      api.reload('2021ac2a', component.options)
    }
    module.hot.accept("./tab10.vue?vue&type=template&id=2021ac2a", function () {
      api.rerender('2021ac2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/require/components/tab10.vue"
export default component.exports